/**
 * Stable KPI ids by dashboard title — used when API rows omit `kpiId` or use an unexpected shape.
 * Keep aligned with oracle-backend `executive-pulse-kpi-catalog.js` titles.
 */
const EXECUTIVE_PULSE_KPI_ID_BY_TITLE = Object.freeze({
    'DB Consults': 'ep-financial-db-consults-1499',
    'Unitas Consults': 'ep-financial-unitas-consults-3701',
    'HSRAs / RAs': 'ep-financial-hsra-500',
    'QBR process rollout': 'ep-customer-qbr-process',
    'Delivered to practices': 'ep-customer-delivered-practices-80pct',
    '100% digital (QBR)': 'ep-customer-digital-100pct',
    'Churn reduction (10% vs baseline)': 'ep-customer-churn-reduction-10pct',
    'Copilot adoption (offices)': 'ep-process-copilot-offices-400',
    'Gross profit return': 'ep-process-gross-profit-600k',
    'Gross profit return ($600K goal)': 'ep-process-gross-profit-600k',
    'People Vision 2028': 'ep-process-people-vision-2028',
    '12-month plan': 'ep-process-12-month-plan',
    'Launch 1A': 'ep-growth-1a-q1-2026',
    'Launch 1B': 'ep-growth-1b-q2-2026'
});

/**
 * @param {object|null|undefined} item
 * @returns {string|null}
 */
const EXECUTIVE_PULSE_PILLARS = ['financial', 'customer', 'process', 'growth'];

function resolveExecutivePulseKpiId(item) {
    if (!item) return null;

    const { kpiId: raw, title } = item;
    if (raw !== undefined && raw !== null && String(raw).trim() !== '') {
        return String(raw).trim();
    }

    if (
        typeof title === 'string' &&
        Object.hasOwn(EXECUTIVE_PULSE_KPI_ID_BY_TITLE, title)
    ) {
        return EXECUTIVE_PULSE_KPI_ID_BY_TITLE[title];
    }

    return null;
}

/**
 * @param {object|null|undefined} dashboard — GET /executive-pulse/dashboard payload
 * @param {string|null|undefined} kpiId
 * @returns {object|null}
 */
export function findExecutivePulseKpiInDashboard(dashboard, kpiId) {
    if (!dashboard || !kpiId) return null;

    const id = String(kpiId).trim();
    return (
        EXECUTIVE_PULSE_PILLARS.map((pillar) => dashboard[pillar] || [])
            .flat()
            .find((row) => resolveExecutivePulseKpiId(row) === id) ?? null
    );
}

export default resolveExecutivePulseKpiId;
